var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"column justify-center items-center"},[_c('img',{style:({ width: '365px', height: '143px' }),attrs:{"src":_vm.src,"alt":"Loading"}})])}
var staticRenderFns = []

export { render, staticRenderFns }